The HTTPS URI that the candidate will be redirected to after completing their authorization.
